import EmitirNFeVenda from './EmitirNFeVenda'

export default function EmitirNFe() {
  return <EmitirNFeVenda />
}
